import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "guides-page" };
const _hoisted_2 = { class: "alert-message" };
const _hoisted_3 = { class: "guides-container" };
const _hoisted_4 = { class: "guide-info" };
const _hoisted_5 = { class: "guide-name" };
const _hoisted_6 = { class: "section-header" };
const _hoisted_7 = { class: "details-grid" };
const _hoisted_8 = { class: "form-section" };
const _hoisted_9 = { class: "form-group" };
const _hoisted_10 = { class: "form-group" };
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = { class: "form-group" };
const _hoisted_13 = { class: "form-group" };
const _hoisted_14 = { class: "form-section" };
const _hoisted_15 = {
    key: 0,
    class: "sections-list"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = { class: "header-actions" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
    key: 0,
    class: "tasks-list"
};
const _hoisted_21 = { class: "section-header" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { class: "header-actions" };
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
    key: 1,
    class: "empty-state-small"
};
const _hoisted_28 = {
    key: 1,
    class: "empty-state-small"
};
const _hoisted_29 = {
    key: 1,
    class: "empty-state-section"
};
const _hoisted_30 = { class: "modal-header" };
const _hoisted_31 = { class: "modal-body" };
const _hoisted_32 = { class: "modal-footer" };
const _hoisted_33 = { class: "modal-header" };
const _hoisted_34 = { class: "modal-body" };
const _hoisted_35 = { class: "form-group" };
const _hoisted_36 = { class: "form-group" };
const _hoisted_37 = { class: "form-group" };
const _hoisted_38 = { class: "form-group" };
const _hoisted_39 = { class: "input-with-button" };
const _hoisted_40 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_41 = ["src"];
const _hoisted_42 = { class: "modal-header" };
const _hoisted_43 = { class: "modal-body" };
const _hoisted_44 = { class: "form-group" };
const _hoisted_45 = { class: "form-group" };
const _hoisted_46 = { class: "form-group" };
const _hoisted_47 = { class: "form-group" };
const _hoisted_48 = { class: "form-group" };
const _hoisted_49 = { class: "form-group" };
const _hoisted_50 = { class: "form-group" };
const _hoisted_51 = { class: "form-group" };
const _hoisted_52 = { class: "input-with-button" };
const _hoisted_53 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_54 = ["src"];
const _hoisted_55 = { class: "modal-header" };
const _hoisted_56 = { class: "modal-body" };
const _hoisted_57 = { class: "search-box" };
const _hoisted_58 = {
    key: 0,
    class: "file-grid"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = { class: "file-preview" };
const _hoisted_61 = ["src", "alt"];
const _hoisted_62 = { class: "file-card-info" };
const _hoisted_63 = ["title"];
const _hoisted_64 = {
    key: 1,
    class: "empty-state-small"
};
import { ref, computed, nextTick, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminHeaderActions from '@/admin/components/AdminHeaderActions.vue';
import AdminListSection from '@/admin/components/AdminListSection.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GuideAdminPage',
    setup(__props) {
        const admin = useAdmin();
        const guideDetailsSection = ref(null);
        const loading = ref(false);
        const selectedGuide = ref(null);
        const showAlert = ref(false);
        const alertMessage = ref('');
        const alertVariant = ref('success');
        const deleteConfirm = ref(false);
        const expandedSections = ref([]);
        const showSectionModal = ref(false);
        const editingSection = ref(null);
        const editingSectionIndex = ref(null);
        const showTaskModal = ref(false);
        const editingTask = ref(null);
        const editingTaskIndex = ref(null);
        const showImageSearchModal = ref(false);
        const cdnFiles = ref([]);
        const imageSearchQuery = ref('');
        const imageTarget = ref(null);
        const guides = computed(() => admin.adminState.guides);
        const filteredCdnFiles = computed(() => {
            if (!cdnFiles.value)
                return [];
            const query = imageSearchQuery.value.toLowerCase();
            return cdnFiles.value.filter((f) => f.fileName.toLowerCase().includes(query) && ['jpg', 'jpeg', 'png', 'gif', 'svg'].some(ext => f.fileName.toLowerCase().endsWith(ext)));
        });
        function loadGuides() { loading.value = true; admin.getGuides((data) => { loading.value = false; if (data && data.length > 0 && !selectedGuide.value)
            selectGuide(data[0]); }); }
        function selectGuide(guide) {
            selectedGuide.value = JSON.parse(JSON.stringify(guide));
            if (!selectedGuide.value.sections)
                selectedGuide.value.sections = [];
            expandedSections.value = [];
            if (window.innerWidth <= 768)
                nextTick(() => guideDetailsSection.value?.scrollIntoView({ behavior: 'smooth' }));
        }
        function newGuide() { selectedGuide.value = { title: '', tagLine: '', description: '', icon: '', tags: '', sections: [] }; expandedSections.value = []; }
        function saveGuide() {
            if (!selectedGuide.value.title) {
                showAlertMessage('Title is required', 'error');
                return;
            }
            loading.value = true;
            if (selectedGuide.value.id)
                admin.updateGuide(selectedGuide.value.id, selectedGuide.value, () => onSaveSuccess(), () => onSaveError('Failed to save guide'));
            else
                admin.createGuide(selectedGuide.value, (res) => onSaveSuccess(res), () => onSaveError('Failed to create guide'));
        }
        function onSaveSuccess(response) {
            showAlertMessage('Guide saved successfully', 'success');
            loading.value = false;
            const newId = response ? response.id : selectedGuide.value.id;
            admin.getGuides((data) => {
                admin.adminState.guides = data || [];
                nextTick(() => {
                    const saved = admin.adminState.guides.find((g) => g.id === newId);
                    if (saved)
                        selectGuide(saved);
                });
            });
        }
        function onSaveError(message) { showAlertMessage(message, 'error'); loading.value = false; }
        function showDeleteConfirmFn() { if (selectedGuide.value?.id)
            deleteConfirm.value = true; }
        function deleteGuideFn() {
            deleteConfirm.value = false;
            loading.value = true;
            admin.deleteGuide(selectedGuide.value.id, () => {
                showAlertMessage('Guide deleted', 'success');
                selectedGuide.value = null;
                loading.value = false;
                refreshGuides();
            }, () => onSaveError('Failed to delete guide'));
        }
        function refreshGuides() { loadGuides(); }
        function showAlertMessage(message, variant = 'success') { alertMessage.value = message; alertVariant.value = variant; showAlert.value = true; setTimeout(() => { showAlert.value = false; }, 4000); }
        function toggleSection(index) { const idx = expandedSections.value.indexOf(index); if (idx > -1)
            expandedSections.value.splice(idx, 1);
        else
            expandedSections.value.push(index); }
        function addSection() { editingSection.value = { title: '', tagLine: '', description: '', icon: '', tasks: [] }; editingSectionIndex.value = null; showSectionModal.value = true; }
        function editSection(s, i) { editingSection.value = { ...s }; editingSectionIndex.value = i; showSectionModal.value = true; }
        function saveSection() {
            if (!editingSection.value.title) {
                showAlertMessage('Section title is required', 'error');
                return;
            }
            if (editingSectionIndex.value !== null)
                selectedGuide.value.sections.splice(editingSectionIndex.value, 1, editingSection.value);
            else
                selectedGuide.value.sections.push(editingSection.value);
            closeSectionModal();
        }
        function deleteSection(i) { selectedGuide.value.sections.splice(i, 1); }
        function closeSectionModal() { showSectionModal.value = false; editingSection.value = null; editingSectionIndex.value = null; }
        function addTask(secIdx) { editingTask.value = { title: '', tagLine: '', description: '', icon: '', completedTitle: '', completedDescription: '', actionTitle: '', actionUrl: '' }; editingSectionIndex.value = secIdx; editingTaskIndex.value = null; showTaskModal.value = true; }
        function editTaskFn(t, secIdx, taskIdx) { editingTask.value = { ...t }; editingSectionIndex.value = secIdx; editingTaskIndex.value = taskIdx; showTaskModal.value = true; }
        function saveTask() {
            if (!editingTask.value.title) {
                showAlertMessage('Task title is required', 'error');
                return;
            }
            const section = selectedGuide.value.sections[editingSectionIndex.value];
            if (editingTaskIndex.value !== null)
                section.tasks.splice(editingTaskIndex.value, 1, editingTask.value);
            else {
                if (!section.tasks)
                    section.tasks = [];
                section.tasks.push(editingTask.value);
            }
            closeTaskModal();
        }
        function deleteTask(secIdx, taskIdx) { selectedGuide.value.sections[secIdx].tasks.splice(taskIdx, 1); }
        function closeTaskModal() { showTaskModal.value = false; editingTask.value = null; editingSectionIndex.value = null; editingTaskIndex.value = null; }
        function openImageSearch(target) {
            imageTarget.value = target;
            showImageSearchModal.value = true;
            loadCdnFiles();
        }
        function loadCdnFiles() { admin.getFiles((files) => { cdnFiles.value = files || []; }); }
        function selectImage(file) {
            if (!imageTarget.value)
                return;
            const { type, field } = imageTarget.value;
            if (type === 'section')
                editingSection.value[field] = file.uri;
            else if (type === 'task')
                editingTask.value[field] = file.uri;
            showImageSearchModal.value = false;
        }
        onMounted(() => { loadGuides(); });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "page-header" }, [
                    _createElementVNode("h1", null, "Guide Administration"),
                    _createElementVNode("p", { class: "subtitle" }, "Manage and configure user financial guides (also known as Plans)")
                ], -1)),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showAlert.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["alert", `alert-${alertVariant.value}`])
                            }, [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(alertMessage.value), 1),
                                _createElementVNode("button", {
                                    class: "alert-close",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (showAlert.value = false))
                                }, "✕")
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(AdminListSection, {
                        title: "Guides",
                        items: guides.value,
                        "selected-id": selectedGuide.value?.id,
                        loading: loading.value,
                        "search-placeholder": "Search guides...",
                        "empty-message": "No guides found",
                        "search-fields": ['title'],
                        onSelect: selectGuide,
                        onRefresh: refreshGuides
                    }, {
                        item: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)
                            ])
                        ]),
                        _: 1
                    }, 8, ["items", "selected-id", "loading"]),
                    (selectedGuide.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            ref_key: "guideDetailsSection",
                            ref: guideDetailsSection,
                            class: "guide-details-section"
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("h2", null, _toDisplayString(selectedGuide.value.title || 'Guide Details'), 1),
                                _createVNode(AdminHeaderActions, {
                                    loading: loading.value,
                                    "has-id": !!selectedGuide.value.id,
                                    onSave: saveGuide,
                                    onDelete: showDeleteConfirmFn,
                                    onNew: newGuide
                                }, null, 8, ["loading", "has-id"])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _cache[35] || (_cache[35] = _createElementVNode("h3", null, "Guide Details", -1)),
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[30] || (_cache[30] = _createElementVNode("label", null, "Title", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedGuide.value.title) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedGuide.value.title]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _cache[31] || (_cache[31] = _createElementVNode("label", null, "Tagline", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedGuide.value.tagLine) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedGuide.value.tagLine]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _cache[32] || (_cache[32] = _createElementVNode("label", null, "Description", -1)),
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedGuide.value.description) = $event)),
                                            class: "form-textarea",
                                            rows: "3"
                                        }, null, 512), [
                                            [_vModelText, selectedGuide.value.description]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[33] || (_cache[33] = _createElementVNode("label", null, "Icon URL", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedGuide.value.icon) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedGuide.value.icon]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                        _cache[34] || (_cache[34] = _createElementVNode("label", null, "Tags (comma-separated)", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedGuide.value.tags) = $event)),
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedGuide.value.tags]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", { class: "section-header" }, [
                                        _cache[36] || (_cache[36] = _createElementVNode("h3", null, "Sections", -1)),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: addSection
                                        }, "➕ Add Section")
                                    ]),
                                    (selectedGuide.value.sections && selectedGuide.value.sections.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedGuide.value.sections, (section, sectionIndex) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: section.id || sectionIndex,
                                                    class: "section-container"
                                                }, [
                                                    _createElementVNode("div", {
                                                        class: "section-item-header",
                                                        onClick: ($event) => (toggleSection(sectionIndex))
                                                    }, [
                                                        _createElementVNode("h4", null, [
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass(["expand-icon", { rotated: expandedSections.value.includes(sectionIndex) }])
                                                            }, "›", 2),
                                                            _createTextVNode(_toDisplayString(section.title || 'Untitled Section'), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_17, [
                                                            _createElementVNode("button", {
                                                                class: "action-btn",
                                                                onClick: _withModifiers(($event) => (editSection(section, sectionIndex)), ["stop"])
                                                            }, "✏️ Edit", 8, _hoisted_18),
                                                            _createElementVNode("button", {
                                                                class: "action-btn danger",
                                                                onClick: _withModifiers(($event) => (deleteSection(sectionIndex)), ["stop"])
                                                            }, "🗑️ Delete", 8, _hoisted_19)
                                                        ])
                                                    ], 8, _hoisted_16),
                                                    _createVNode(_Transition, { name: "expand" }, {
                                                        default: _withCtx(() => [
                                                            (expandedSections.value.includes(sectionIndex))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                                    _createElementVNode("div", _hoisted_21, [
                                                                        _cache[37] || (_cache[37] = _createElementVNode("h5", null, "Tasks", -1)),
                                                                        _createElementVNode("button", {
                                                                            class: "action-btn secondary",
                                                                            onClick: ($event) => (addTask(sectionIndex))
                                                                        }, "➕ Add Task", 8, _hoisted_22)
                                                                    ]),
                                                                    (section.tasks && section.tasks.length > 0)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.tasks, (task, taskIndex) => {
                                                                                return (_openBlock(), _createElementBlock("div", {
                                                                                    key: task.id || taskIndex,
                                                                                    class: "task-item"
                                                                                }, [
                                                                                    _createElementVNode("span", null, _toDisplayString(task.title || 'Untitled Task'), 1),
                                                                                    _createElementVNode("div", _hoisted_24, [
                                                                                        _createElementVNode("button", {
                                                                                            class: "action-btn",
                                                                                            onClick: _withModifiers(($event) => (editTaskFn(task, sectionIndex, taskIndex)), ["stop"])
                                                                                        }, "✏️ Edit", 8, _hoisted_25),
                                                                                        _createElementVNode("button", {
                                                                                            class: "action-btn danger",
                                                                                            onClick: _withModifiers(($event) => (deleteTask(sectionIndex, taskIndex)), ["stop"])
                                                                                        }, "🗑️ Delete", 8, _hoisted_26)
                                                                                    ])
                                                                                ]));
                                                                            }), 128))
                                                                        ]))
                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[38] || (_cache[38] = [
                                                                            _createElementVNode("p", null, "No tasks in this section.", -1)
                                                                        ])))
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[39] || (_cache[39] = [
                                            _createElementVNode("p", null, "No sections defined for this guide.", -1)
                                        ])))
                                ])
                            ])
                        ], 512))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[40] || (_cache[40] = [
                            _createElementVNode("p", null, "Select a guide to view details", -1)
                        ])))
                ]),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (deleteConfirm.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: _cache[9] || (_cache[9] = ($event) => (deleteConfirm.value = false))
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog",
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_30, [
                                        _cache[41] || (_cache[41] = _createElementVNode("h3", null, "Confirm Delete", -1)),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (deleteConfirm.value = false))
                                        }, "✕")
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("p", null, [
                                            _cache[42] || (_cache[42] = _createTextVNode("Are you sure you want to delete ")),
                                            _createElementVNode("strong", null, _toDisplayString(selectedGuide.value.title), 1),
                                            _cache[43] || (_cache[43] = _createTextVNode("?"))
                                        ]),
                                        _cache[44] || (_cache[44] = _createElementVNode("p", null, "This action cannot be undone.", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: _cache[7] || (_cache[7] = ($event) => (deleteConfirm.value = false))
                                        }, "Cancel"),
                                        _createElementVNode("button", {
                                            class: "action-btn danger",
                                            onClick: deleteGuideFn
                                        }, "Delete")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showSectionModal.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: closeSectionModal
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog",
                                    onClick: _cache[15] || (_cache[15] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("h3", null, _toDisplayString(editingSectionIndex.value === null ? 'Add' : 'Edit') + " Section", 1),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: closeSectionModal
                                        }, "✕")
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                            _cache[45] || (_cache[45] = _createElementVNode("label", null, "Title", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((editingSection.value.title) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSection.value.title]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                            _cache[46] || (_cache[46] = _createElementVNode("label", null, "Tagline", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((editingSection.value.tagLine) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingSection.value.tagLine]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_37, [
                                            _cache[47] || (_cache[47] = _createElementVNode("label", null, "Description", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((editingSection.value.description) = $event)),
                                                class: "form-textarea",
                                                rows: "3"
                                            }, null, 512), [
                                                [_vModelText, editingSection.value.description]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_38, [
                                            _cache[48] || (_cache[48] = _createElementVNode("label", null, "Icon URL", -1)),
                                            _createElementVNode("div", _hoisted_39, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((editingSection.value.icon) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, editingSection.value.icon]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "action-btn",
                                                    type: "button",
                                                    onClick: _cache[14] || (_cache[14] = ($event) => (openImageSearch({ type: 'section', field: 'icon' })))
                                                }, "🖼️")
                                            ]),
                                            (editingSection.value.icon)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                    _createElementVNode("img", {
                                                        src: editingSection.value.icon,
                                                        alt: "Icon Preview",
                                                        class: "image-preview"
                                                    }, null, 8, _hoisted_41)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: closeSectionModal
                                        }, "Cancel"),
                                        _createElementVNode("button", {
                                            class: "action-btn primary",
                                            onClick: saveSection
                                        }, "Save")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showTaskModal.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: closeTaskModal
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog",
                                    onClick: _cache[25] || (_cache[25] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_42, [
                                        _createElementVNode("h3", null, _toDisplayString(editingTaskIndex.value === null ? 'Add' : 'Edit') + " Task", 1),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: closeTaskModal
                                        }, "✕")
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("div", _hoisted_44, [
                                            _cache[49] || (_cache[49] = _createElementVNode("label", null, "Title", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((editingTask.value.title) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingTask.value.title]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_45, [
                                            _cache[50] || (_cache[50] = _createElementVNode("label", null, "Tagline", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((editingTask.value.tagLine) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingTask.value.tagLine]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_46, [
                                            _cache[51] || (_cache[51] = _createElementVNode("label", null, "Description", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((editingTask.value.description) = $event)),
                                                class: "form-textarea",
                                                rows: "3"
                                            }, null, 512), [
                                                [_vModelText, editingTask.value.description]
                                            ])
                                        ]),
                                        _cache[57] || (_cache[57] = _createElementVNode("hr", { class: "modal-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_47, [
                                            _cache[52] || (_cache[52] = _createElementVNode("label", null, "Action Title", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((editingTask.value.actionTitle) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingTask.value.actionTitle]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_48, [
                                            _cache[53] || (_cache[53] = _createElementVNode("label", null, "Action URL", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((editingTask.value.actionUrl) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingTask.value.actionUrl]
                                            ])
                                        ]),
                                        _cache[58] || (_cache[58] = _createElementVNode("hr", { class: "modal-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_49, [
                                            _cache[54] || (_cache[54] = _createElementVNode("label", null, "Completed Title", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((editingTask.value.completedTitle) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, editingTask.value.completedTitle]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                            _cache[55] || (_cache[55] = _createElementVNode("label", null, "Completed Description", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((editingTask.value.completedDescription) = $event)),
                                                class: "form-textarea",
                                                rows: "2"
                                            }, null, 512), [
                                                [_vModelText, editingTask.value.completedDescription]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_51, [
                                            _cache[56] || (_cache[56] = _createElementVNode("label", null, "Icon URL", -1)),
                                            _createElementVNode("div", _hoisted_52, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((editingTask.value.icon) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, editingTask.value.icon]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "action-btn",
                                                    type: "button",
                                                    onClick: _cache[24] || (_cache[24] = ($event) => (openImageSearch({ type: 'task', field: 'icon' })))
                                                }, "🖼️")
                                            ]),
                                            (editingTask.value.icon)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                    _createElementVNode("img", {
                                                        src: editingTask.value.icon,
                                                        alt: "Icon Preview",
                                                        class: "image-preview"
                                                    }, null, 8, _hoisted_54)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: closeTaskModal
                                        }, "Cancel"),
                                        _createElementVNode("button", {
                                            class: "action-btn primary",
                                            onClick: saveTask
                                        }, "Save")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showImageSearchModal.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: _cache[29] || (_cache[29] = ($event) => (showImageSearchModal.value = false))
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog modal-large",
                                    onClick: _cache[28] || (_cache[28] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_55, [
                                        _cache[59] || (_cache[59] = _createElementVNode("h3", null, "Select an Image", -1)),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: _cache[26] || (_cache[26] = ($event) => (showImageSearchModal.value = false))
                                        }, "✕")
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("div", _hoisted_57, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((imageSearchQuery).value = $event)),
                                                type: "text",
                                                placeholder: "Search images...",
                                                class: "search-input"
                                            }, null, 512), [
                                                [_vModelText, imageSearchQuery.value]
                                            ])
                                        ]),
                                        (cdnFiles.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCdnFiles.value, (file) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: file.fileName,
                                                        class: "file-card",
                                                        onClick: ($event) => (selectImage(file))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_60, [
                                                            _createElementVNode("img", {
                                                                src: file.uri,
                                                                alt: file.fileName
                                                            }, null, 8, _hoisted_61)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_62, [
                                                            _createElementVNode("div", {
                                                                class: "file-card-name",
                                                                title: file.fileName
                                                            }, _toDisplayString(file.fileName), 9, _hoisted_63)
                                                        ])
                                                    ], 8, _hoisted_59));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_64, _cache[60] || (_cache[60] = [
                                                _createElementVNode("p", null, "No images found in CDN.", -1)
                                            ])))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
